(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19978],{

/***/ 12901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ListingFilters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67379);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11213);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _lib_shared_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(198);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);







let valuesHasBeenSetFromQuery = false;
function ListingFilters({ handleSubmit , submitButtonText , submitButtonStyle , className , selectQuestionClassName , toggleQuestionClassName , textQuestionClassName , rowClassName , questionsClassName , toggleButtonClassName , isQuestionSameRow =false , noMinimize =false , fireSubmitOnEnterKeyWord =false  }) {
    const { modal , setQuestionValue  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)();
    const [boxHeight, setBoxHeight] = react__WEBPACK_IMPORTED_MODULE_3__.useState(0);
    const { 0: active , 1: setActive  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const boxRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { questions: listingQuestions  } = modal.listing;
    const handleQuestionOnChange = (name, value)=>{
        let newVal = value;
        const question = listingQuestions[name];
        if (question?.type === "text" && question.mask === "zipCode") {
            newVal = (0,_lib_shared_form__WEBPACK_IMPORTED_MODULE_4__/* .handleFieldMasking */ .yr)("zipCode", value);
        }
        setQuestionValue({
            name,
            value: newVal
        });
    };
    const gettingQuestion = (question, key)=>{
        switch(question.type){
            case "select":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SelectQuestion, {
                    question: question,
                    onChange: handleQuestionOnChange,
                    value: listingQuestions[question.name]?.value ?? "",
                    className: selectQuestionClassName
                }, key);
            case "toggle":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ToggleQuestion, {
                    question: question,
                    onChange: handleQuestionOnChange,
                    className: toggleQuestionClassName
                }, key);
            case "text":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextQuestion, {
                    question: question,
                    onChange: handleQuestionOnChange,
                    value: listingQuestions[question.name]?.value ?? "",
                    className: textQuestionClassName,
                    handleSubmit: handleSubmit,
                    fireSubmitOnEnterKeyWord: fireSubmitOnEnterKeyWord
                }, key);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        setTimeout(()=>{
            setBoxHeight(boxRef.current?.scrollHeight ?? 0);
        }, 1000);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (Object.keys(listingQuestions).length && !valuesHasBeenSetFromQuery) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const filters = router.query.filters ? JSON.parse((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .base64DecodeUnicode */ .e1)(router.query.filters)) : localStorage?.getItem("filters") ? JSON.parse(localStorage.getItem("filters")) : null;
            if (filters) {
                Object.keys(filters).forEach((filterKey)=>{
                    if (listingQuestions[filterKey]) {
                        setQuestionValue({
                            name: filterKey,
                            value: filters[filterKey]
                        });
                    }
                });
                valuesHasBeenSetFromQuery = true;
            }
        }
    }, [
        listingQuestions
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["listing-filters"])} ${className ?? ""}`,
        id: "listing-filters",
        children: [
            !noMinimize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["toggle-button"])} ${toggleButtonClassName ? toggleButtonClassName : ""}`,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    onClick: ()=>setActive(!active),
                    children: [
                        active ? "Hide" : "Show",
                        " Filters"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: boxRef,
                style: {
                    height: !noMinimize ? active ? boxHeight : 0 : undefined,
                    opacity: !noMinimize ? active ? 1 : 0 : undefined,
                    marginBottom: !noMinimize ? active ? "1rem" : 0 : undefined
                },
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inner),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().questions)} ${questionsClassName}`,
                    children: [
                        !isQuestionSameRow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().row)} ${rowClassName ?? ""}`,
                            children: Object.keys(listingQuestions).map((questionKey, index)=>{
                                const question = listingQuestions[questionKey];
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
                                    children: question?.type === "text" && gettingQuestion(question, index)
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().row)} ${!isQuestionSameRow ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().boxes) : ""} ${rowClassName ?? ""}`,
                            style: {
                                width: isQuestionSameRow ? "100%" : undefined
                            },
                            children: Object.keys(listingQuestions).map((questionKey, index)=>{
                                const question = listingQuestions[questionKey];
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
                                    children: isQuestionSameRow ? question && gettingQuestion(question, index) : question?.type === "select" && gettingQuestion(question, index)
                                }, index);
                            })
                        }),
                        !isQuestionSameRow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().row)} ${rowClassName ?? ""}`,
                            children: Object.keys(listingQuestions).map((questionKey, index)=>{
                                const question = listingQuestions[questionKey];
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
                                    children: question?.type === "toggle" && gettingQuestion(question, index)
                                }, index);
                            })
                        }),
                        handleSubmit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().submit)} ${submitButtonStyle ?? ""}`,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                onClick: handleSubmit,
                                children: submitButtonText ?? "Update"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
const TextQuestion = ({ question , onChange , value , className , handleSubmit , fireSubmitOnEnterKeyWord =false  })=>{
    const handleKeyDown = (event)=>{
        if (event.key === "Enter" && fireSubmitOnEnterKeyWord && handleSubmit) {
            event.preventDefault();
            handleSubmit();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[`${question.name}`],
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["text-question"])} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().question)} ${className ?? ""}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
            type: question.fieldType,
            name: question.name,
            value: value ?? "",
            onChange: (e)=>onChange(question.name, e.target.value),
            id: question.name,
            placeholder: question.placeholder,
            maxLength: question.maxLength,
            onKeyDown: handleKeyDown
        })
    });
};
const ToggleQuestion = ({ question , onChange , className  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["toggle-question"])} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().question)} ${className ?? ""}`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "checkbox",
                name: question.name,
                value: question.value,
                onChange: (e)=>onChange(question.name, e.target.checked ? "1" : "0"),
                id: question.name,
                checked: question.value === "1" ? true : false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: question.name,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: question.label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().checkbox),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            viewBox: "0,0,50,50",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M5 30 L 20 45 L 45 5"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const SelectQuestion = ({ question , onChange , value , className  })=>{
    const gettingOptionLabel = (value)=>{
        const activeOption = question.options?.filter((option)=>{
            return option.value === value;
        }) || [];
        return activeOption[0] ? activeOption[0].label : question.placeholder;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[`${question.name}`],
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["select-question"])} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().question)} ${className ?? ""}`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                children: question.label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().value),
                children: gettingOptionLabel(question.value)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                name: question.name,
                value: !value ? "placeholder" : question.name === "birthDate" ? value.split("-")[0] : value,
                onChange: (e)=>onChange(question.name, e.target.value),
                children: [
                    question.placeholder && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                        value: "placeholder",
                        disabled: true,
                        children: question.placeholder
                    }),
                    question.options?.map((option, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                            value: option.value,
                            children: option.label
                        }, index))
                ]
            })
        ]
    });
};


/***/ }),

/***/ 13628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ questions; }
/* harmony export */ });
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75094);

const questions = {
    auto: [
        {
            label: "Zip Code",
            type: "text",
            value: "",
            name: "zipCode",
            isInHomePage: true,
            fieldType: "tel",
            placeholder: "Enter your zip code",
            mask: "zipCode",
            maxLength: 5
        },
        {
            label: "Birth Year:",
            type: "select",
            options: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .gettingYears */ .Ln)(1927, 2002).map((year)=>({
                    label: `${year}`,
                    value: `${year}`
                })),
            value: "1985",
            name: "birthDate",
            isInHomePage: true
        },
        {
            label: "Vehicles No.",
            type: "select",
            options: [
                {
                    label: "1",
                    value: "1"
                },
                {
                    label: "2",
                    value: "2"
                },
                {
                    label: "3",
                    value: "3"
                },
                {
                    label: "4",
                    value: "4"
                },
                {
                    label: "5+",
                    value: "5"
                }, 
            ],
            value: "1",
            name: "vehicleCount",
            isInHomePage: true
        },
        {
            label: "Currently Insured? ",
            type: "toggle",
            value: "0",
            name: "currentlyInsured",
            isInHomePage: true
        },
        {
            label: "Homeowner? ",
            type: "toggle",
            value: "0",
            name: "homeOwnership",
            isInHomePage: true
        },
        {
            label: "Married?",
            type: "toggle",
            value: "0",
            name: "currentlyMarried",
            isInHomePage: false
        }, 
    ],
    life: [
        {
            label: "Zip Code",
            type: "text",
            value: "",
            name: "zipCode",
            isInHomePage: true,
            fieldType: "tel",
            placeholder: "Enter your zip code",
            mask: "zipCode",
            maxLength: 5
        },
        {
            label: "Birth Year:",
            type: "select",
            options: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .gettingYears */ .Ln)(1927, 2002).map((year)=>({
                    label: `${year}`,
                    value: `${year}`
                })),
            value: "1985",
            name: "birthDate",
            isInHomePage: true
        },
        {
            label: "Gender:",
            type: "select",
            options: [
                {
                    label: "Male",
                    value: "M"
                },
                {
                    label: "Female",
                    value: "F"
                },
                {
                    label: "Other",
                    value: "X"
                }, 
            ],
            value: "",
            name: "gender",
            placeholder: "Select",
            isInHomePage: true
        },
        {
            label: "Height:",
            type: "select",
            options: [
                {
                    label: `5' 0"`,
                    value: "60"
                },
                {
                    label: `5' 1"`,
                    value: "61"
                },
                {
                    label: `5' 2"`,
                    value: "62"
                },
                {
                    label: `5' 3"`,
                    value: "63"
                },
                {
                    label: `5' 4"`,
                    value: "64"
                },
                {
                    label: `5' 5"`,
                    value: "65"
                },
                {
                    label: `5' 6"`,
                    value: "66"
                },
                {
                    label: `5' 7"`,
                    value: "67"
                },
                {
                    label: `5' 8"`,
                    value: "68"
                },
                {
                    label: `5' 9"`,
                    value: "69"
                },
                {
                    label: `5' 10"`,
                    value: "70"
                },
                {
                    label: `6' 0"`,
                    value: "72"
                },
                {
                    label: `6' 1"`,
                    value: "73"
                },
                {
                    label: `6' 2"`,
                    value: "74"
                },
                {
                    label: `6' 3"`,
                    value: "75"
                },
                {
                    label: `6' 4"`,
                    value: "76"
                },
                {
                    label: `6' 5"`,
                    value: "77"
                },
                {
                    label: `6' 6"`,
                    value: "78"
                },
                {
                    label: `6' 7"`,
                    value: "79"
                },
                {
                    label: `6' 8"`,
                    value: "80"
                },
                {
                    label: `6' 9"`,
                    value: "81"
                },
                {
                    label: `6' 10"`,
                    value: "82"
                }, 
            ],
            value: "72",
            name: "height",
            isInHomePage: true
        },
        {
            label: "Weight:",
            type: "select",
            options: new Array(36).fill(0).map((_, i)=>({
                    value: `${100 + i * 10}`,
                    label: `${100 + i * 10}`
                })),
            value: "140",
            name: "weight",
            isInHomePage: true
        },
        {
            label: "Coverage amount:",
            type: "select",
            options: [
                {
                    label: "$50,000 or less",
                    value: "50000"
                },
                {
                    label: "$100,000",
                    value: "100000"
                },
                {
                    label: "$250,000",
                    value: "250000"
                },
                {
                    label: "$500,000",
                    value: "500000"
                },
                {
                    label: "$750,000",
                    value: "750000"
                },
                {
                    label: "$1,000,000",
                    value: "1000000"
                },
                {
                    label: "$1,500,000",
                    value: "1500000"
                },
                {
                    label: "$2,500,000+",
                    value: "2500000"
                }, 
            ],
            value: "500000",
            name: "coverageAmount",
            isInHomePage: true
        },
        {
            label: "Smoker?",
            type: "toggle",
            value: "0",
            name: "tobacco",
            isInHomePage: true
        }, 
    ],
    health: [
        {
            label: "Zip Code",
            type: "text",
            value: "",
            name: "zipCode",
            isInHomePage: true,
            fieldType: "tel",
            placeholder: "Enter your zip code",
            mask: "zipCode",
            maxLength: 5
        },
        {
            label: "Birth Year:",
            type: "select",
            options: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .gettingYears */ .Ln)(1927, 2002).map((year)=>({
                    label: `${year}`,
                    value: `${year}`
                })),
            value: "1985",
            name: "birthDate",
            isInHomePage: true
        },
        {
            label: "Gender:",
            type: "select",
            options: [
                {
                    label: "Male",
                    value: "M"
                },
                {
                    label: "Female",
                    value: "F"
                },
                {
                    label: "Other",
                    value: "X"
                }, 
            ],
            value: "",
            name: "gender",
            placeholder: "Select",
            isInHomePage: true
        },
        {
            label: "Household income?",
            type: "select",
            options: [
                {
                    label: "$50,000 or less",
                    value: "50000"
                },
                {
                    label: "$100,000",
                    value: "100000"
                },
                {
                    label: "$250,000",
                    value: "250000"
                },
                {
                    label: "$500,000",
                    value: "500000"
                },
                {
                    label: "$750,000",
                    value: "750000"
                },
                {
                    label: "$1,000,000",
                    value: "1000000"
                },
                {
                    label: "$1,500,000",
                    value: "1500000"
                },
                {
                    label: "$2,500,000+",
                    value: "2500000"
                }, 
            ],
            value: "500000",
            name: "householdIncome",
            isInHomePage: true
        }, 
    ],
    medicare: [
        {
            label: "Zip Code",
            type: "text",
            value: "",
            name: "zipCode",
            isInHomePage: true,
            fieldType: "tel",
            placeholder: "Enter your zip code",
            mask: "zipCode",
            maxLength: 5
        },
        {
            label: "Birth Year:",
            type: "select",
            options: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .gettingYears */ .Ln)(1927, 2002).map((year)=>({
                    label: `${year}`,
                    value: `${year}`
                })),
            value: "1957",
            name: "birthDate",
            isInHomePage: true
        },
        {
            label: "Gender:",
            type: "select",
            options: [
                {
                    label: "Male",
                    value: "M"
                },
                {
                    label: "Female",
                    value: "F"
                },
                {
                    label: "Other",
                    value: "X"
                }, 
            ],
            value: "",
            name: "gender",
            placeholder: "Select",
            isInHomePage: true
        },
        {
            label: "Credit Rating",
            type: "select",
            options: [
                {
                    label: "Excellent",
                    value: "excellent"
                },
                {
                    label: "Good",
                    value: "good"
                },
                {
                    label: "Average",
                    value: "average"
                },
                {
                    label: "Below Average",
                    value: "below average"
                },
                {
                    label: "Poor",
                    value: "poor"
                }, 
            ],
            value: "good",
            name: "creditRating"
        }, 
    ],
    "clinical-trials": [
        {
            label: "Zip Code",
            type: "text",
            value: "",
            name: "zipCode",
            isInHomePage: true,
            fieldType: "tel",
            placeholder: "Enter your zip code",
            mask: "zipCode",
            maxLength: 5
        }, 
    ]
};


/***/ }),

/***/ 11213:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","listing-filters":"styles_listing-filters__GbM8o","toggle-button":"styles_toggle-button__QbjD_","inner":"styles_inner__6Nl2J","questions":"styles_questions__O9iKM","row":"styles_row__qvCUh","boxes":"styles_boxes___VSrh","question":"styles_question__Nke2g","submit":"styles_submit__tTn9i","select-question":"styles_select-question__7p7OE","value":"styles_value__2N_xe","coverageAmount":"styles_coverageAmount__6Qrq7","householdIncome":"styles_householdIncome__7LxPB","gender":"styles_gender__I_p4m","birthDate":"styles_birthDate__8GnGm","weight":"styles_weight__ZdqZk","height":"styles_height___V55J","vehicleCount":"styles_vehicleCount__yZ4kK","toggle-question":"styles_toggle-question__4QKIF","checkbox":"styles_checkbox__li55p","text-question":"styles_text-question__aawZ7","zipCode":"styles_zipCode__V3p6n"};

/***/ })

}]);